import React, { Component } from 'react';
import i18n from 'i18n-react';
import { spring, StaggeredMotion } from 'react-motion';

import { storageKeys, baseAppId } from 'settings';
import { APIHandler, DataHandler, StorageHandler, TrainingCard, SubAppButton, ContentHeader } from 'C4';

export default class TrainingGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appId: 0,
      chapters: [],
      chapters_progress: [],
      subApps: [],
    };

    this.isLocked = this.isLocked.bind(this);
    this.loadChapters = this.loadChapters.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.getProgress();
    this.setSubApps(baseAppId);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getProgress() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res.response;
        const { appId } = window;
        if (this.mounted) {
          this.setState({ appId });
          DataHandler.checkKey(storageKeys.progress, APIHandler.getUserProgress(appId, email))
            .then((userProgress) => {
              this.calculateProgress(userProgress);
            });
        }
      }
    });
  }

  getSubAppProgress(appIds) {
    return StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res.response;
        if (this.mounted && appIds.apps.length > 0) {
          return APIHandler.getUserProgress(appIds.apps, email)
            .then((userProgress) => {
              const progress = Object.values(userProgress.data).map((app) => {
                const [chapter] = app.chapters;
                const { name } = app;
                return {
                  chapter,
                  name,
                };
              });
              return progress;
            });
        }
      }
      return null;
    });
  }

  setSubApps(appId) {
    return APIHandler.getSubApps(appId)
      .then((ids) => {
        this.getSubAppProgress(ids).then((progress) => {
          if (progress) {
            const subAppPromises = ids.apps.map((id, i) => {
              const pageId = progress[i].chapter.last_page < progress[i].chapter.total_pages
                ? progress[i].chapter.last_page
                : 0;
              const key = i;
              return APIHandler.getChapters(id)
                .then((chapter) => {
                  const [newApp] = chapter.app;
                  return (
                    <SubAppButton
                      key={`${key}_${newApp.chapterImage}`}
                      appId={id}
                      progress={progress[i].chapter}
                      name={progress[i].name}
                      pageId={pageId}
                      size={{ height: 50, width: 50 }}
                      type="training"
                    />
                  );
                });
            });
            if (this.mounted) {
              return Promise.all(subAppPromises)
                .then((subApps) => {
                  this.setState({ subApps });
                });
            } return null;
          } return null;
        });
      });
  }

  loadChapters(setProgress) {
    const { appId } = this.state;
    DataHandler.checkKey(storageKeys.chapters, APIHandler.getChapters(appId), true)
      .then((res) => {
        const startingValues = [];
        Object.keys(res.app).map(() => {
          const newObj = {};
          newObj.data = 0;
          newObj.pos = 20;
          return startingValues.push(newObj);
        });
        if (!setProgress) {
          StorageHandler.load(storageKeys.user).then((user) => {
            APIHandler.registerUserProgress(user.response.email).then((registered) => {
              if (registered) {
                this.getProgress();
              }
            });
          });
        } else {
          const chapters = (
            <StaggeredMotion
              defaultStyles={startingValues}
              styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
                ? { data: spring(1, { stiffness: 320, damping: 28 }), pos: spring(0, { stiffness: 320, damping: 28 }) }
                : { data: spring(prevInterpolatedStyles[i - 1].data, { stiffness: 320, damping: 28 }), pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
            >
              {styles => (
                <React.Fragment>

                  {res.app.map((chapter, key) => (
                    <>
                      {key === 0 && <div className="subheader"><h1>Value Based Selling</h1><div className="line"></div></div> }
                      {key === 3 && <div className="subheader"><h1> Confidence Based Closing</h1><div className="line"></div></div> }
                      {key === 7 && <div className="subheader"><h1>Professional Prospecting</h1><div className="line"></div></div> }
                      {key === 10 && <div className="subheader"><h1>Product</h1><div className="line"></div></div> }
                      <div key={key} className="trainingCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                        <TrainingCard
                          chaptersProgress={this.state.chapters_progress[key]}
                          chapter={chapter}
                          chapterCount={chapter.chapterItemCount}
                          locked={this.isLocked(key)}
                          index={key}
                          appId={appId}
                          key={chapter.chapterID}
                        />
                      </div>
                    </>
                  ))}

                </React.Fragment>
              )}
            </StaggeredMotion>);
          this.setState({ chapters });
        }
      });
  }

  calculateProgress(res) {
    if (res.status !== 'error') {
      const { chapters } = res.data[0];
      chapters.forEach((chapter) => {
        const newChapter = chapter;
        if (chapter.progress > 0 && chapter.total_pages > 0) {
          newChapter.percentage = (chapter.progress / chapter.total_pages) * 100;
          if (newChapter.percentage > 100) { newChapter.percentage = 100; }
        }
      });
      this.setState({ chapters_progress: chapters }, () => {
        this.loadChapters(res.status !== 'error');
      });
    }
    this.loadChapters(res.status !== 'error');
  }

  isLocked(key) {
    const { chapters_progress: progress } = this.state;
    if (progress.length > 0 && (key === 0 || progress[0].percentage === 100)) {
      return false;
    }
    return true;
  }

  render() {
    const { chapters, subApps } = this.state;
    return (
      <div>
        {chapters && subApps &&
          <div>
            <div className="trainingGrid">
              {chapters}
            </div>
            {subApps.length > 0 &&
              <ContentHeader
                header={i18n.translate('contentHeaders.subapps')}
                subtitle={i18n.translate('pageDescriptions.subapps')}
              />
            }
            <div className="trainingGrid subApps">
              {subApps}
            </div>
          </div>}
      </div>
    );
  }
}
